import { render, staticRenderFns } from "./MdDropDownIcon.vue?vue&type=template&id=316ef5e3"
import script from "./MdDropDownIcon.vue?vue&type=script&lang=js"
export * from "./MdDropDownIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports